import { DefaultTag, ErrorTag, InProgressTag, SuccessTag, WarningTag } from '@lib/common';
import { hasSubmissionSubmitTime, PracticeSubmissionStatusResult, SubmissionStatusId } from '@module/assignment';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var getAttendeeSubmissionStatusId = function getAttendeeSubmissionStatusId(attendee) {
  var _attendee$report$stat, _attendee$report$stat2;

  return (_attendee$report$stat = (_attendee$report$stat2 = attendee.report.status) === null || _attendee$report$stat2 === void 0 ? void 0 : _attendee$report$stat2.id) !== null && _attendee$report$stat !== void 0 ? _attendee$report$stat : SubmissionStatusId.NONE;
};

export var getAttendeeSubmissionExpiryTime = function getAttendeeSubmissionExpiryTime(attendee) {
  var expiredAt = attendee.report.expiredAt;
  if (!expiredAt) return null;
  var normalizedExpiredAt = String(expiredAt).trim();
  var numericExpiredAt = Number(normalizedExpiredAt);
  if (!normalizedExpiredAt || !Number.isFinite(numericExpiredAt)) return null;
  return normalizedExpiredAt.length === 10 ? numericExpiredAt * 1000 : numericExpiredAt;
};

var isAttendeeSubmissionAwaitingExpiry = function isAttendeeSubmissionAwaitingExpiry(attendee) {
  return (getAttendeeSubmissionStatusId(attendee) === SubmissionStatusId.ONGOING || getAttendeeSubmissionStatusId(attendee) === SubmissionStatusId.PAUSED) && !hasSubmissionSubmitTime(attendee.report.submitTime) && !attendee.report.rejectionInfo;
};

export var isAttendeeSubmissionExpired = function isAttendeeSubmissionExpired(attendee) {
  var currentTimeMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  var isAssignmentEnded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (getAttendeeSubmissionStatusId(attendee) === SubmissionStatusId.NONE) {
    return isAssignmentEnded || attendee.report.expired === true;
  }

  if (!isAttendeeSubmissionAwaitingExpiry(attendee)) return false;
  var expiryTime = getAttendeeSubmissionExpiryTime(attendee);
  return isAssignmentEnded || attendee.report.expired === true || Boolean(attendee.report.closedAt) || expiryTime != null && expiryTime <= currentTimeMs;
};
export var isAttendeeSubmissionCountingDown = function isAttendeeSubmissionCountingDown(attendee) {
  var currentTimeMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();

  if (getAttendeeSubmissionStatusId(attendee) !== SubmissionStatusId.ONGOING || !isAttendeeSubmissionAwaitingExpiry(attendee) || attendee.report.expired === true || Boolean(attendee.report.closedAt)) {
    return false;
  }

  var expiryTime = getAttendeeSubmissionExpiryTime(attendee);
  return expiryTime != null && expiryTime > currentTimeMs;
};
export var getTranslatedSubmissionStatusKey = function getTranslatedSubmissionStatusKey(attendee, currentTimeMs, isAssignmentEnded) {
  if (isAttendeeSubmissionExpired(attendee, currentTimeMs, isAssignmentEnded)) {
    return 'submissionStatusExpired';
  }

  switch (getAttendeeSubmissionStatusId(attendee)) {
    case SubmissionStatusId.ONGOING:
      return 'submissionStatusOnGoing';

    case SubmissionStatusId.PAUSED:
      return 'submissionStatusPaused';

    case SubmissionStatusId.BANNED:
      return 'submissionStatusBanned';

    case SubmissionStatusId.SUBMITTED:
      {
        var _attendee$report = attendee.report,
            gradedPercentage = _attendee$report.gradedPercentage,
            isSubmissionPassed = _attendee$report.isSubmissionPassed;

        if (gradedPercentage < 100 || isSubmissionPassed == null) {
          return 'submissionStatusSubmitted';
        }

        return isSubmissionPassed ? 'submissionStatusPassed' : 'submissionStatusFailed';
      }

    case PracticeSubmissionStatusResult.PASSED:
      return 'submissionStatusPassed';

    case PracticeSubmissionStatusResult.FAILED:
      return 'submissionStatusFailed';

    case SubmissionStatusId.NONE:
      {
        return 'submissionStatusNone';
      }

    default:
      {
        return 'None';
      }
  }
};
export var AttendeeSubmissionStatusComponent = function AttendeeSubmissionStatusComponent(_ref) {
  var attendee = _ref.attendee,
      text = _ref.text,
      currentTimeMs = _ref.currentTimeMs,
      isAssignmentEnded = _ref.isAssignmentEnded,
      isPractice = _ref.isPractice;

  if (isAttendeeSubmissionExpired(attendee, currentTimeMs, isAssignmentEnded)) {
    return /*#__PURE__*/_jsx(ErrorTag, {
      children: text
    });
  }

  switch (getAttendeeSubmissionStatusId(attendee)) {
    case SubmissionStatusId.ONGOING:
      return /*#__PURE__*/_jsx(InProgressTag, {
        children: text
      });

    case SubmissionStatusId.PAUSED:
      return /*#__PURE__*/_jsx(WarningTag, {
        children: text
      });

    case SubmissionStatusId.BANNED:
      return /*#__PURE__*/_jsx(ErrorTag, {
        children: text
      });

    case SubmissionStatusId.SUBMITTED:
      {
        var _attendee$report2 = attendee.report,
            isSubmissionPassed = _attendee$report2.isSubmissionPassed,
            gradedPercentage = _attendee$report2.gradedPercentage;

        if (gradedPercentage < 100 || isSubmissionPassed == null) {
          return isPractice ? /*#__PURE__*/_jsx(DefaultTag, {
            color: "purple",
            children: text
          }) : /*#__PURE__*/_jsx(InProgressTag, {
            children: text
          });
        }

        return isSubmissionPassed ? /*#__PURE__*/_jsx(SuccessTag, {
          children: text
        }) : /*#__PURE__*/_jsx(ErrorTag, {
          children: text
        });
      }

    case PracticeSubmissionStatusResult.PASSED:
      return /*#__PURE__*/_jsx(SuccessTag, {
        children: text
      });

    case PracticeSubmissionStatusResult.FAILED:
      return /*#__PURE__*/_jsx(ErrorTag, {
        children: text
      });

    case SubmissionStatusId.NONE:
      {
        return text ? /*#__PURE__*/_jsx(DefaultTag, {
          children: text
        }) : /*#__PURE__*/_jsx(ErrorTag, {
          children: "None"
        });
      }

    default:
      {
        return /*#__PURE__*/_jsx(_Fragment, {});
      }
  }
};